import WinBase from '../components/base/win-base';
import { LabeledInput } from '../components/fields';

const FootballWin = () => {
  return (
    <WinBase sportType="football">
      <div className="mt-4">
        <LabeledInput
          name="settings.winPenaltySeries"
          placeholder="0 очков"
          label="В серии послематчевых пенальти"
          containerClassName="flex items-center"
          tooltip="Количество очков за победу по пенальти (если основное и дополнительное время не выявили победителя)."
          tooltipProps={{ position: 'input-right' }}
        />
      </div>
    </WinBase>
  );
};

export default FootballWin;
